export default "__VITE_ASSET__jOHx9bLb__"